/**
 * @file
 * YMCA accordion.
 */

(function ($, Drupal, once) {

  'use strict';

  /**
   * YMCA accordion.
   */
  Drupal.behaviors.ymcaSwoLbAccordion = {
    attach: function (context, settings) {
      once('ymca-accordion', '.block-layout-builder.block-accordion', context)
        .forEach(function (element) {
          const $block = $(element);
          const $collapseAll = $block.find('.ymca-accordion-collapse-all');
          const $expandAll = $block.find('.ymca-accordion-expand-all');

          const $firstButton = $block.find('.accordion-button').first();
          const isFirstExpanded = $firstButton.attr('aria-expanded') === 'true';

          if (isFirstExpanded) {
            $expandAll.hide();
            $collapseAll.show();
          } else {
            $expandAll.show();
            $collapseAll.hide();
          }

          $expandAll.on('click', function (e) {
            e.preventDefault();

            $block.find('.accordion .collapse').collapse('show');

            $expandAll.hide();
            $collapseAll.show();
          });

          $collapseAll.on('click', function (e) {
            e.preventDefault();

            $block.find('.accordion .collapse').collapse('hide');

            $expandAll.show();
            $collapseAll.hide();
          });
        });
    },
  };
})(jQuery, Drupal, once);
